const normalizeSessionCode = (sessionId) => (sessionId || '').toString().trim().toUpperCase();

const getStorageKey = (sessionId) => `cookup_session_version_${normalizeSessionCode(sessionId)}`;

export const getSessionVersion = (sessionId) => {
  const code = normalizeSessionCode(sessionId);
  if (!code) return null;

  const raw = sessionStorage.getItem(getStorageKey(code));
  const parsed = Number(raw);
  return Number.isInteger(parsed) && parsed >= 0 ? parsed : null;
};

export const setSessionVersion = (sessionId, version) => {
  const code = normalizeSessionCode(sessionId);
  if (!code || !Number.isInteger(version) || version < 0) return;
  sessionStorage.setItem(getStorageKey(code), String(version));
};

export const clearSessionVersion = (sessionId) => {
  const code = normalizeSessionCode(sessionId);
  if (!code) return;
  sessionStorage.removeItem(getStorageKey(code));
};
